import React, { Component } from "react";
import s from "./styles.scss";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import CargaComisionesManualesTable from "./CargaComisionesManuales.table";
import { CargaComisionesManualesStore } from "../../../containers/comisionesManuales/generacion/CargaComisionesManuales.store";
import { CargaComisionesManualesDispatcher } from "../../../containers/comisionesManuales/generacion/CargaComisionesManuales.dispatcher";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { Styled } from "../../../../toolkit/decorators/Artifact";

interface Props
  extends CargaComisionesManualesStore,
    CargaComisionesManualesDispatcher {}

interface State {
  selectedFile: File | null;
  mostrarBotonConfirmar: boolean;
}

@Styled(s)
export default class CargaComisionesManualesComponent extends Component<
  Props,
  State
> {
  state = {
    selectedFile: null,
    mostrarBotonConfirmar: false
  };

  onFileChange = evt => {
    if (evt.target.files && evt.target.files.length > 0) {
      this.props.clearComisionesManualExtras();
      this.setState({
        selectedFile: evt.target.files[0],
        mostrarBotonConfirmar: false
      });
    }
  };

  onValidarCarga = async () => {
    const { selectedFile } = this.state;

    if (!selectedFile) {
      errorNotification("Debe seleccionar un archivo Excel");
      return;
    }

    const preview = await this.props.cargarComisionesDesdeExcel(
      selectedFile,
      false
    );

    if (preview.fulfilled) {
      const resultado = preview.comisionManualCarga;

      if (
        resultado &&
        resultado.comisiones &&
        resultado.comisiones.length > 0
      ) {
        const hasErrors = resultado.registrosConError > 0;

        if (!hasErrors) {
          successNotification(`Validación completa, confirme la carga.`);
          this.setState({ mostrarBotonConfirmar: true });
        } else {
          errorNotification(
            `${resultado.registrosConError} registros contienen errores.`
          );
          this.setState({ mostrarBotonConfirmar: false });
        }
      } else {
        errorNotification("No se encontraron registros para procesar");
        this.setState({ mostrarBotonConfirmar: false });
      }
    } else {
      errorNotification(
        preview.postingComisionManualExcelError ||
          "Error al validar la carga de comisiones"
      );
      this.setState({ mostrarBotonConfirmar: false });
    }
  };

  onConfirmarCarga = async () => {
    const { selectedFile } = this.state;

    const preview = await this.props.cargarComisionesDesdeExcel(
      selectedFile,
      true
    );

    if (preview.fulfilled) {
      this.setState({ mostrarBotonConfirmar: false, selectedFile: null });

      const resultado = preview.comisionManualCarga;
      successNotification(
        `${resultado.registrosExitosos} comisiones creadas correctamente.`
      );
    } else {
      errorNotification(
        preview.postingComisionManualExcelError ||
          "Error al confirmar la carga de comisiones"
      );
    }
  };

  isWaiting = () => {
    return this.props.postingComisionManualExcel;
  };

  spinnerOnWait = (label: string) => {
    return this.isWaiting() ? (
      <FontAwesomeIcon icon={faSpinner} pulse />
    ) : (
      label
    );
  };

  render() {
    const { comisionManualCarga } = this.props;
    const { selectedFile, mostrarBotonConfirmar } = this.state;
    const layoutHref =
      "https://docs.google.com/spreadsheets/d/1ZvtmcnH3UJba_kZA8qDd6Y4C0W-Ro52Y";

    return (
      <>
        <div className="container">
          <div className="row mt-3">
            <div className="col-12">
              <div className="alert alert-info">
                <p className="mt-2 mb-0">
                  Puede descargar el layout de ejemplo{" "}
                  <a
                    href={layoutHref}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    aquí
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md-3">
              <Button
                type="button"
                className={`${s.primaryButton} ${s.fileButton}`}
                size="sm"
                block
                disabled={
                  this.isWaiting() ||
                  (!!this.state.selectedFile && !!comisionManualCarga)
                }
                onClick={e => {
                  if (
                    this.isWaiting() ||
                    (!!this.state.selectedFile && !!comisionManualCarga)
                  ) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
              >
                {this.spinnerOnWait("Seleccionar archivo")}
                <input
                  className={s.inputFile}
                  type="file"
                  accept=".xlsx,.xls"
                  title=""
                  disabled={
                    this.isWaiting() ||
                    (!!this.state.selectedFile && !!comisionManualCarga)
                  }
                  onChange={this.onFileChange}
                />
              </Button>
              {selectedFile && (
                <small className="text-muted d-block mt-1">
                  {selectedFile.name}
                </small>
              )}
            </div>

            <div className="col-md-3">
              {selectedFile && !comisionManualCarga && (
                <>
                  <Button
                    className={`${s.primaryButton}`}
                    type="button"
                    size="sm"
                    block
                    onClick={this.onValidarCarga}
                    disabled={this.isWaiting()}
                  >
                    {this.spinnerOnWait("Validar carga")}
                  </Button>
                </>
              )}

              {selectedFile && !!comisionManualCarga && (
                <>
                  <Button
                    className={`${s.primaryButton}`}
                    type="button"
                    size="sm"
                    block
                    onClick={() => {
                      this.props.clearComisionesManualExtras();
                      this.setState({
                        selectedFile: null,
                        mostrarBotonConfirmar: false
                      });
                    }}
                    disabled={this.isWaiting()}
                  >
                    {this.spinnerOnWait("Reintentar")}
                  </Button>
                </>
              )}
            </div>

            <div className="col-md-3">
              {mostrarBotonConfirmar && (
                <>
                  <Button
                    color="success"
                    type="button"
                    size="sm"
                    block
                    onClick={this.onConfirmarCarga}
                    disabled={this.isWaiting()}
                  >
                    {this.spinnerOnWait("Confirmar carga")}
                  </Button>
                </>
              )}
            </div>
          </div>

          {comisionManualCarga &&
            comisionManualCarga.comisiones &&
            comisionManualCarga.comisiones.length > 0 && (
              <div className="mt-4">
                <CargaComisionesManualesTable
                  comisiones={comisionManualCarga.comisiones}
                />
              </div>
            )}
        </div>
      </>
    );
  }
}
